import axios from 'axios';
import authService from '../api-authorization/AuthorizeService';

const SESSION_EXPIRED_EVENT_NAME = 'syncstats:session-expired';

const handleUnauthorized = () => {
    if (typeof window === 'undefined') return;

    const returnUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT_NAME, {
        detail: { returnUrl }
    }));
};

const isPermissionDeniedValidationResult = (payload) => {
    if (!payload || typeof payload !== 'object') return false;
    if (payload.message !== 'Validation Failed') return false;
    if (!Array.isArray(payload.errors)) return false;

    return payload.errors.some((e) =>
        e && typeof e.field === 'string' && e.field.toLowerCase() === 'permissiondenied'
    );
};

const httpClient = async (method, url, data) => {
    const token = await authService.getAccessToken();
    let result;

    try {
        switch (method) {
            case 'get':
                result = await axios({
                    method: method,
                    url: url,
                    params: data,
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                })
                break;

            case 'delete':
                result = await axios({
                    method: method,
                    url: url,
                    params: data,
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                })
                break;

            case 'formFile':
                result = await axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'content-type': 'multipart/form-data' },
                })
                break;

            case 'deletePost':
                result = await axios({
                    method: 'delete',
                    url: url,
                    data: data,
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                })
                break;

            default:
                result = await axios({
                    method: method,
                    url: url,
                    data: data,
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                })
                break;
        }
    } catch (err) {
        const status = err && err.response ? err.response.status : null;
        if (status === 401 || status === 403) {
            handleUnauthorized();
        }
        throw err;
    }

    if (isPermissionDeniedValidationResult(result && result.data ? result.data : null)) {
        handleUnauthorized();
    }

    return result.data;
}
export default httpClient;
